<osp-panel
  #panel
>
  <!-- HEADER -->
  <ng-template ospTemplate="header">
    <div class="flex align-items-center gap-1">
      <span>{{ this.translate('shared.geofence.addGeofence') }}</span>
    </div>
  </ng-template>

  <div class="create-geofence-form-container">
    <osp-create-geofence-form
      [map]="map()"
      [geofenceOptions]="$geofenceOptions()"
      (onReset)="handleCancelAction()"
      (onCreate)="handleCreateAction($event)"
    />
  </div>
</osp-panel>
